import React, { useEffect, useRef, useState } from 'react';
import { FiChevronDown, FiFileText, FiFolderPlus, FiUpload } from 'react-icons/fi';
import { MdNotes } from 'react-icons/md';
import { MdAdd } from 'react-icons/md';
import { useStorageBox } from '../StorageBoxContext';

export default function StorageBoxNewMenu() {
  const { readOnly, writable, fileInputRef, openCreateFolderModal, openNewTextFileModal, handleUpload } =
    useStorageBox();
  const [menuOpen, setMenuOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const close = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', close);
    document.addEventListener('touchstart', close, { passive: true });
    return () => {
      document.removeEventListener('mousedown', close);
      document.removeEventListener('touchstart', close);
    };
  }, [menuOpen]);

  if (readOnly || !writable) return null;

  const menuClass = ['sb-drive-new-menu', menuOpen ? 'sb-drive-new-menu--open' : ''].filter(Boolean).join(' ');

  return (
    <div ref={wrapRef} className="sb-drive-new-wrap sb-drive-new-wrap--toolbar">
      <button
        type="button"
        className="sb-drive-new-btn"
        aria-label="New"
        aria-haspopup="menu"
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen((open) => !open)}
      >
        <MdAdd aria-hidden />
        <span className="sb-drive-new-btn__label">New</span>
        <FiChevronDown className="sb-drive-new-chevron" aria-hidden />
      </button>
      <div className={menuClass} role="menu">
        <button
          type="button"
          role="menuitem"
          onClick={() => {
            setMenuOpen(false);
            openCreateFolderModal();
          }}
        >
          <FiFolderPlus aria-hidden /> Folder
        </button>
        <button
          type="button"
          role="menuitem"
          onClick={() => {
            setMenuOpen(false);
            openNewTextFileModal('plain');
          }}
        >
          <FiFileText aria-hidden /> Text file
        </button>
        <button
          type="button"
          role="menuitem"
          onClick={() => {
            setMenuOpen(false);
            openNewTextFileModal('rich');
          }}
        >
          <MdNotes aria-hidden /> Rich text
        </button>
        <button
          type="button"
          role="menuitem"
          onClick={() => {
            setMenuOpen(false);
            fileInputRef.current?.click();
          }}
        >
          <FiUpload aria-hidden /> File upload
        </button>
      </div>
      <input
        ref={fileInputRef}
        type="file"
        multiple
        className="sb-hidden-input"
        onChange={(e) => {
          handleUpload(e.target.files, null);
          e.target.value = '';
        }}
      />
    </div>
  );
}
